<template>
  <div class="input-container">
    <span class="question">
      {{ question }}
      <asterisk v-if="isRequired" />
    </span>
    <div class="row">
      <div class="answer">
        <label :for="componentID + '-answer-yes'" class="label">Да</label>
        <input
          type="radio"
          class="input"
          value="yes"
          :checked="defaultValue === 'yes'"
          @change="$emit('handleSelect', $event.target.value)"
          :name="componentID"
          :id="componentID + '-answer-yes'"
        />
      </div>
      <div class="answer">
        <label :for="componentID + '-answer-no'" class="label">Нет</label>
        <input
          type="radio"
          class="input"
          value="no"
          :checked="defaultValue === 'no'"
          @change="$emit('handleSelect', $event.target.value)"
          :name="componentID"
          :id="componentID + '-answer-no'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Asterisk from "@/components/register/Asterisk";

export default {
  props: {
    componentID: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    question: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: String,
      default: "yes"
    }
  },
  components: {
    asterisk: Asterisk
  }
};
</script>

<style scoped>
.input-container {
  color: #ffffff;
}

.row {
  display: flex;
}

.answer {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.label {
  margin-right: 5px;
}
</style>
